/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import { Response } from '@neo4j-ndl/react/ai';

const markdownContent = `
# Hello World

This is a **bold** text and this is an *italic* text.

Here is a list:
- Item 1
- Item 2
- Item 3

And a code block:

\`\`\`typescript
const greeting = "Hello World";
console.log(greeting);
\`\`\`

[Link to Neo4j](https://neo4j.com)
`;

export const Component = () => {
  return <Response>{markdownContent}</Response>;
};

export default Component;
